// eslint-disable react/no-unknown-property
import React from "react";
import { useState } from "react";
import { useLocation } from "react-router";

import { css } from "@emotion/react";

export const Search: React.FC<{ noButton?: boolean }> = ({ noButton }) => {
  const { search } = useLocation();
  const [question, setQuestion] = useState(
    new URLSearchParams(search).get("q"),
  );
  return (
    <form
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
      `}
      action="/ask"
    >
      <input
        css={css`
          display: block;
          font-size: 24px;
          border-radius: 16px;
          padding: 8px 16px;
          width: 33vw;
          min-width: 300px;
        `}
        type="text"
        name="q"
        autoComplete="off"
        placeholder="Search"
        value={question ?? ""}
        onChange={(e) => setQuestion(e.target.value)}
      />
      {!noButton && (
        <div
          css={css`
            margin-top: 8px;
          `}
        >
          <input
            css={css`
              font-size: 24px;
              padding: 4px 16px;
              border-radius: 8px;
            `}
            type="submit"
            value="Search"
          />
        </div>
      )}
    </form>
  );
};
